export enum UserStatus {
	ACTIVE = 'A',
	INACTIVE = 'I',
	DELETED = 'D'
}